import React from "react";
import { Box } from "@mui/material";
import { Navigate } from "react-router-dom";
import SubTitle from "../common/SubTitle";
import NavMenu from "../navbar/NavMenu";
import AppSettings from "./AppSettings";
import HomeHeader from "../header/homeHeader/HomeHeader";
import TitleBar from "../../components/navbar/TitleBar";
import Footer from "../common/Footer";
import { PAGE_IDS, isJsonDrivenLayoutEnabled } from "../../config/uiLayoutConfig";
import { usePageLayout } from "../../context/LayoutContext";
import { getPageTitleKey } from "../../layout/settingsLayoutUtils";

export default function AppSettingsContainer() {
  const useJsonLayout = isJsonDrivenLayoutEnabled();
  const { layout: moduleLayout } = usePageLayout(
    useJsonLayout ? PAGE_IDS.FLEET_SETTINGS : null,
  );
  const pageTitle = getPageTitleKey(moduleLayout) || "Settings";

  // Get organizationId from localStorage
  let organizationId = null;
  try {
    const userStateString = localStorage.getItem("userState");
    if (userStateString) {
      const userState = JSON.parse(userStateString);
      organizationId = userState.user.organizationId;
    }
  } catch (error) {
    console.error("Error retrieving organizationId from localStorage:", error);
  }

  // Redirect to login if no organizationId
  if (!organizationId) {
    return <Navigate to="/login" replace />;
  }
  const orgName = JSON.parse(localStorage.getItem('userState'))?.organization?.name;

  return (
    <>
      <Box >
        <TitleBar />
        <NavMenu />
        <SubTitle
          title={pageTitle}
          path={`${orgName || "organization"}> Settings`} />
        <AppSettings />
      </Box>
      <Footer />
    </>
  );
}